// 侧边栏是否显示 默认显示
export const isSideList = [
  '/wisdomCalculate/wisdomCenter',
  '/wisdomCalculate/algorithmLibrary',
  '/wisdomCalculate/perceptionTerminal',
  '/wisdomCalculate/assessDetermine',
  '/wisdomCalculate/IntelligentAgentCluster',
  '/OverallSituation/main',
  '/manageCenter/Synthesize',
  '/controlCenter/taskStatistics',
  '/manageCenter/manualFlight',
  '/detection/jinmuliangcao',
  '/user/profile',
  '/governance/big-screen'
];

// 面包屑是否显示 默认显示
export const isBreadcrumbList = [
  '/governance/big-screen',
  '/wisdomCalculate/wisdomCenter',
  '/wisdomCalculate/algorithmLibrary',
  '/wisdomCalculate/perceptionTerminal',
  '/wisdomCalculate/assessDetermine',
  '/wisdomCalculate/IntelligentAgentCluster',
  '/OverallSituation/main',
  '/manageCenter/manualFlight',
  '/manageCenter/Synthesize',
  '/controlCenter/taskStatistics',
  '/workCenter/taskManger',
  '/workCenter/airLineMange',
  '/flightCenter/airport',
  '/flightCenter/AccessConfig',
  '/flightCenter/drone',
  '/flightCenter/Robot',
  '/workCenter/flyArea',
  '/workCenter/orderInfo',
  '/workCenter/mapModel',
  '/workCenter/mapAnnotation',
  '/sysCenter/sysUser',
  '/sysCenter/sysDept',
  '/sysCenter/sysRole',
  '/sysCenter/operateLog',
  '/sysCenter/downloadLog',
  '/sysCenter/reportConfig',
  '/sysCenter/aiAlarmConfig',
  '/sysCenter/alarmSetting',
  '/sysCenter/aiModel',
  '/sysCenter/deviceLink',
  '/sysCenter/shoutConfig',
  '/workCenter/reportRecord',
  '/flightCenter/Methane',
  '/workCenter/pipSet',
  '/workCenter/ConstructionManagement',
  '/workCenter/staffWorkSchedule',
  '/flightCenter/deviceFirmware',
  '/flightCenter/fiberShock',
  '/flightCenter/loadVideo',
  '/detection/jinmuliangcao',
  '/sysCenter/addUser',
  '/sysCenter/editUser',
  '/sysCenter/details',
  '/sysCenter/editRole',
  '/sysCenter/sysSetting',
  '/sysCenter/appVersion'
];

export const isNavbar = [
  '/governance/big-screen',
  '/wisdomCalculate/wisdomCenter',
  '/wisdomCalculate/algorithmLibrary',
  '/wisdomCalculate/perceptionTerminal',
  '/wisdomCalculate/assessDetermine',
  '/wisdomCalculate/IntelligentAgentCluster',
  '/OverallSituation/main',
  '/manageCenter/manualFlight',
  '/detail'
];
//任务中枢、资产管理等头部显示,放入数组才显示
export const isNewNavBar = [
  '/Taskhub/IntelligentDispatch',
  '/Taskhub/taskdata',
  '/Taskhub/taskrecord',
  '/Taskhub/routeplan',
  '/equipmentAssetsManage/equipment',
  '/equipmentAssetsManage/maintenance',
  '/equipmentAssetsManage/dataAsset',
  '/Inspection/riskEvent',
  '/Inspection/riskWarning',
  '/Inspection/AlChangeWarning',
  '/Inspection/statisticalReport',
  '/safetyControl/regionalSecurity',
  '/safetyControl/meteorologicalSafety',
  '/safetyControl/flightSafety',
  '/safetyControl/AlarmFence',
  '/Taskhub/mapScene',
  '/Taskhub/InspectionPlanning'
];

//需要展示水印的业务页面路由,放入数组才显示（试用租户）；/detail 单机任务详情不走布局，水印在页面内单独接入
export const WATERMARK_ROUTES = [
  '/Taskhub/IntelligentDispatch',
  '/Taskhub/taskdata',
  '/Taskhub/taskrecord',
  '/Taskhub/routeplan',
  '/equipmentAssetsManage/equipment',
  '/equipmentAssetsManage/maintenance',
  '/equipmentAssetsManage/dataAsset',
  '/Inspection/riskEvent',
  '/Inspection/riskWarning',
  '/Inspection/AlChangeWarning',
  '/Inspection/statisticalReport',
  '/OverallSituation/main'
];
